<template>
  <div class="audio-container">

    <v-icon @click="togglePlay" size="18" color="blue">
      {{ isPlaying ? "mdi-pause-circle-outline" : "mdi-play-circle-outline" }}
    </v-icon>

    <div class="waveform" @click="seekAudio">
      <div v-for="(bar, index) in bars" :key="index" class="bar"
        :style="{ height: bar + 'px', opacity: getOpacity(index) }"></div>
    </div>

    <!-- Time Display -->
    <span class="time">{{ formattedTime }}</span>

    <!-- Mute/Un-Mute Button -->
    <v-icon @click="toggleMute" size="16" color="black">
      {{ isMuted ? "mdi-volume-off" : "mdi-volume-high" }}
    </v-icon>

    <!-- Playback Speed Button -->
    <button class="speed-btn" @click="changeSpeed">
      {{ playbackRate }}x
    </button>
    <!-- Audio Element -->
    <audio ref="audio" :src="src" @timeupdate="updateProgress" @ended="resetPlayer" @loadedmetadata="initializeAudio"
      @waiting="isBuffering = true" @playing="isBuffering = false" preload="none"></audio>
  </div>
</template>

<script>
export default {
  name: "AudioPlayer",
  props: {
    src: {
      type: String,
      required: true,
    },

  },
  data() {
    return {
      isPlaying: false,
      currentTime: 0,
      duration: 1,
      previousVolume: 1,
      isMuted: false,
      bars: Array.from({ length: 20 }, () => Math.floor(Math.random() * 15) + 5),
      isBuffering: false,
      loaded : false,
      playbackRate: 1, 
      speedOptions: [1, 1.25, 1.5, 2], 
      speedIndex: 0,
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.currentTime / 60);
      const secs = Math.floor(this.currentTime % 60);
      return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    },
  },
  methods: {
    togglePlay() {
      try {
        const audio = this.$refs.audio;
        if (audio.paused) {
          audio.play().catch(err => console.error("Play error:", err));
          this.isPlaying = true;
        } else {
          audio.pause();
          this.isPlaying = false;
        }
      } catch (error) {
        console.warn(error);
      }
    },
    updateProgress() {
      const audio = this.$refs.audio;
      this.currentTime = audio.currentTime;
      this.duration = audio.duration || 1;
    },
    resetPlayer() {
      this.isPlaying = false;
      this.currentTime = 0;
    },
    getOpacity(index) {
      const progress = (this.currentTime / this.duration) * this.bars.length;
      return index < progress ? 1.2 : 0.3;
    },
    initializeAudio() {
      const audio = this.$refs.audio;
      if (audio.readyState >= 2 && isFinite(audio.duration) && audio.duration > 0) {
        this.duration = parseInt(audio.duration);
        this.loaded = true;
        audio.playbackRate = this.playbackRate;
      }
    },
    seekAudio(event) {
      const audio = this.$refs.audio;

      if (!audio || isNaN(audio.duration) || !isFinite(audio.duration) || audio.duration === 0) {
        return;
      }

      const rect = event.currentTarget.getBoundingClientRect();
      const clickPosition = event.clientX - rect.left;
      const percentage = clickPosition / rect.width;

      audio.currentTime = Math.min(audio.duration * percentage, audio.duration);
    },
    toggleMute() {
      const audio = this.$refs.audio;
      if (!audio) return;

      if (this.isMuted) {
        // Restore the previous volume
        audio.volume = this.previousVolume;
      } else {
        // Store the current volume before muting
        this.previousVolume = audio.volume;
        audio.volume = 0;
      }
      this.isMuted = !this.isMuted;
    },  
    changeSpeed() {
           const audio = this.$refs.audio;
  if (!audio) return;
   
      this.speedIndex = (this.speedIndex + 1) % this.speedOptions.length;
      this.playbackRate = this.speedOptions[this.speedIndex];      
      audio.playbackRate = this.playbackRate;
    },
  },
  mounted() {
    this.previousVolume = this.$refs.audio ? this.$refs.audio.volume : 1; // Initialize volume
  }
};
</script>

<style scoped>
.audio-container {
  display: flex;
  align-items: center;
  width: min-content;
  gap: 5px;
}

.waveform {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 25px;
  cursor: pointer;
}

.bar {
  width: 1.5px;
  background: #000;
  transition: height 0.1s ease, opacity 0.2s ease-in-out;
}

.time {
  font-size: 12px;
  color: #000;
}

.speed-btn {
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  padding: 2px 6px;
}
</style>
